import { Suspense } from 'react';
import { createCrumbHandle } from '../../utilities/auth';
import Loader from '../../globalComponents/loader/DPLoader';
import FMListing from '../../pages/FileManager/FMListing';


const fileManagementRoute = [
  {
    path: '/file-management/:assetId',
    handle: createCrumbHandle('File Management'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <FMListing />
          </Suspense>
        ),
      },
    ]
  },
];

export default fileManagementRoute;
